<div class="empty-state-v2" [ngClass]="[customClass]">
  <div class="empty-state-icon">
    <lucide-icon [name]="resolvedIcon" [size]="48"></lucide-icon>
  </div>
  <h5 class="empty-state-title">{{ title | translate }}</h5>
  @if (description) {
    <p class="empty-state-description mb-2">{{ description | translate }}</p>
  }
  <ng-content></ng-content>
</div>
